import React from "react";
import { axiosdelete } from "../../helpers/httprequest";
import is_null from "../../helpers/is_null";
import swal from "../../helpers/swal";
import Modal from "react-modal";
import { useQueryClient } from "@tanstack/react-query";

const DelReferee = ({ modules }) => {
  const [showmodal, setshowmodal] = React.useState(false);
  const [name, setname] = React.useState(null);
  const [loading, setloading] = React.useState(false);
  const queryClient = useQueryClient();

  const _save = async () => {
    try {
      setloading(true);
      if (is_null(name) || name !== "Delete") {
        swal("error", "Please fill the form properly", setloading);
        return;
      }
      const req = await axiosdelete(`ms_applicant_referee/${modules._id}`);
      if (req.status !== 200) throw new Error("Sorry something went wrong, please try again");
      const { type, message } = req.data;
      swal(type, message, setloading, true);
      if (type === "success") {
        queryClient.invalidateQueries({ queryKey: ["listOfReferees"] });
        _close();
      }
    } catch ({ message }) {
      swal("error", message, setloading);
    }
  };
  const _close = () => {
    setshowmodal(false);
    setname("");
  };
  const _show = () => {
    setshowmodal(true);
    setname(modules !== undefined ? modules.name : null);
  };

  return (
    <div>
      <Modal isOpen={showmodal} onRequestClose={() => setshowmodal(false)} className="ReactModal">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-center text-danger">
                Delete {modules.firstname} {modules.lastname}
              </h5>
            </div>
            <div className="modal-body">
              <div className="text-wrap my-4 text-md">
                To delete this parent/guaridan? type the word <b className="text-danger">Delete</b> in the text box:
              </div>
              <div className="form-group">
                <input
                  type="email"
                  className="form-control form-control-lg"
                  id="exampleInputEmail2"
                  placeholder="Delete"
                  onChange={(e) => setname(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                {loading ? (
                  <button type="button" className="btn btn-primary">
                    Please wait...
                  </button>
                ) : (
                  <button type="button" className="btn btn-primary" onClick={_save}>
                    Delete Record
                  </button>
                )}

                <button type="button" className="btn btn-danger" onClick={() => setshowmodal(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <div>
        <button className="btn btn-icon btn-danger btn-rounded" onClick={_show}>
          <i className="ti-trash"></i>
        </button>
      </div>
    </div>
  );
};

export default DelReferee;
